export const TICKETS_DATA = "TICKETS_DATA";
export const TICKETS_START_LOADER = "TICKETS_START_LOADER";
export const TICKETS_STOP_LOADER = "TICKETS_STOP_LOADER";
export const TICKETS_HIDE_ERROR = "TICKETS_HIDE_ERROR";
export const TICKETS_ERROR = "TICKETS_ERROR";
